import React from "react";
import {
  FaChartPie,
  FaDatabase,
  FaCheckDouble,
  FaCompass,
} from "react-icons/fa";
import "./ValuePropSection.scss";

const ValuePropSection = () => {
  return (
    <section className="value-prop-section py-5 bg-white border-bottom position-relative overflow-hidden">
      {/* Background Glowing Orbs */}
      <div className="value-prop-bg-orbs"></div>

      <div className="container py-3 position-relative z-1">
        <div className="row align-items-center">
          <div className="col-lg-5 mb-5 mb-lg-0 animate-fade-up pe-lg-5">
            <h2
              className="fw-bold display-6 text-dark mb-4"
              style={{ lineHeight: "1.2" }}
            >
              How Our Research Creates Better Decisions
            </h2>
            <p
              className="text-muted"
              style={{
                lineHeight: "1.7",
                fontSize: "1.1rem",
                textAlign: "justify",
              }}
            >
              Reliable market intelligence is built through disciplined
              research, careful validation, and objective analysis. Every study
              follows a structured process designed to provide balanced insights
              that organizations can use with confidence.
            </p>
          </div>
          <div className="col-lg-7">
            <div className="row g-4">
              <div className="col-md-6 animate-fade-up delay-1">
                <div className="animated-glow-card h-100">
                  <div className="glow-inner d-flex align-items-start p-3 h-100">
                    <div className="icon-wrapper text-primary d-flex align-items-center justify-content-center bg-light rounded shadow-sm flex-shrink-0 me-3">
                      <FaChartPie size={24} />
                    </div>
                    <div>
                      <h4 className="fw-bold h6 mb-2 text-dark">
                        Comprehensive Market Understanding
                      </h4>
                      <p
                        className="text-muted small mb-0"
                        style={{ lineHeight: "1.6" }}
                      >
                        Every study begins by clearly defining the market,
                        identifying key segments, understanding value chains,
                        and establishing the factors influencing market growth.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 animate-fade-up delay-2">
                <div className="animated-glow-card h-100">
                  <div className="glow-inner d-flex align-items-start p-3 h-100">
                    <div className="icon-wrapper text-primary d-flex align-items-center justify-content-center bg-light rounded shadow-sm flex-shrink-0 me-3">
                      <FaDatabase size={24} />
                    </div>
                    <div>
                      <h4 className="fw-bold h6 mb-2 text-dark">
                        Multi-Source Research
                      </h4>
                      <p
                        className="text-muted small mb-0"
                        style={{ lineHeight: "1.6" }}
                      >
                        Our analysts synthesize information from credible
                        secondary sources, industry publications, company
                        disclosures, trade associations, government data,
                        regulatory information, and expert perspectives where
                        appropriate.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 animate-fade-up delay-3">
                <div className="animated-glow-card h-100">
                  <div className="glow-inner d-flex align-items-start p-3 h-100">
                    <div className="icon-wrapper text-primary d-flex align-items-center justify-content-center bg-light rounded shadow-sm flex-shrink-0 me-3">
                      <FaCheckDouble size={24} />
                    </div>
                    <div>
                      <h4 className="fw-bold h6 mb-2 text-dark">
                        Rigorous Analysis & Validation
                      </h4>
                      <p
                        className="text-muted small mb-0"
                        style={{ lineHeight: "1.6" }}
                      >
                        Research findings are evaluated using structured
                        analytical frameworks and cross-validated across
                        multiple information sources to improve consistency,
                        reliability, and accuracy.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 animate-fade-up delay-4">
                <div className="animated-glow-card h-100">
                  <div className="glow-inner d-flex align-items-start p-3 h-100">
                    <div className="icon-wrapper text-primary d-flex align-items-center justify-content-center bg-light rounded shadow-sm flex-shrink-0 me-3">
                      <FaCompass size={24} />
                    </div>
                    <div>
                      <h4 className="fw-bold h6 mb-2 text-dark">
                        Decision-Oriented Insights
                      </h4>
                      <p
                        className="text-muted small mb-0"
                        style={{ lineHeight: "1.6" }}
                      >
                        Beyond presenting data, every report is developed to
                        help organizations interpret market developments,
                        identify opportunities, understand risks, and support
                        strategic decision-making.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValuePropSection;
